import { defineComponent as y, useSlots as N, computed as t, useAttrs as V, createElementBlock as B, openBlock as w, normalizeClass as n, createElementVNode as i, renderSlot as S, mergeProps as A } from "vue";
import { usePropsValidation as z } from "../../composables/usePropsValidation.js";
import { omit as E } from "../../utils/omit.js";
import { tw as e } from "../../utils/tailwind.js";
import { CHANGE_EVENT as T } from "./RadioBase.constant.js";
const R = ["id", "checked", "disabled", "value"], $ = /* @__PURE__ */ y({
  name: "RevRadioBase",
  inheritAttrs: !1,
  __name: "RadioBase",
  props: {
    modelValue: { type: [Boolean, String] },
    disabled: { type: Boolean, default: !1 },
    id: {},
    label: {},
    value: {},
    checkmarkClassNames: { type: [String, Boolean, Array, Object], default: "" },
    checkmarkTickClassNames: { type: [String, Boolean, Array, Object], default: e`left-6 top-8` }
  },
  emits: ["change", "update:modelValue"],
  setup(o, { emit: m }) {
    const a = o, p = N(), d = m, u = t(() => !!p.default), s = t(() => !u.value), r = t(() => typeof a.modelValue == "string" ? a.modelValue === a.value : a.modelValue);
    function b(l) {
      l.target.value !== a.modelValue && (d(T, l), d("update:modelValue", l.target.value));
    }
    z({
      "If no slot is passed, `props.label` is mandatory": () => s.value && !a.label
    });
    const f = t(() => {
      const l = V();
      return {
        ...E(l, ["class"]),
        ...s.value && a.label && {
          "aria-label": a.label
        }
      };
    }), v = t(() => [
      e`relative`,
      s.value && e`size-20`
    ]), h = t(() => [
      e`peer appearance-none outline-none`,
      u.value && e`sr-only`,
      s.value && e`rounded-full absolute inset-x-0 bottom-0 top-2 size-20`,
      s.value && !a.disabled && e`cursor-pointer`,
      s.value && a.disabled && e`cursor-not-allowed`
    ]), c = e`rounded-full pointer-events-none absolute`, k = t(() => [
      c,
      a.checkmarkClassNames,
      e`box-border size-20 border`,
      s.value && "left-0 top-2 peer-focus-visible:outline-default-hi",
      r.value ? e`bg-action-default-low-pressed` : e`bg-action-default-low`,
      a.disabled && e`bg-action-default-low-disabled border-action-default-hi-disabled`,
      a.disabled && r.value && e`border-transparent`
    ]), C = t(() => [
      c,
      a.checkmarkTickClassNames,
      e`bg-action-default-low size-8 shrink-0`,
      a.disabled && e`bg-action-default-low-pressed opacity-50`,
      r.value ? e`block` : e`hidden`
    ]);
    return (l, g) => (w(), B("div", {
      class: n([l.$attrs.class, v.value])
    }, [
      i("input", A({ id: o.id }, f.value, {
        checked: r.value,
        class: h.value,
        disabled: o.disabled,
        type: "radio",
        value: o.value,
        onChange: b
      }), null, 16, R),
      S(l.$slots, "default"),
      i("div", {
        class: n(k.value)
      }, null, 2),
      i("div", {
        class: n(C.value)
      }, null, 2)
    ], 2));
  }
});
export {
  $ as default
};
